<form class="list-dmrl-container">
  <div class="pure-g">
    <div class="pure-u-md-10-24 pure-u-lg-14-24">
      <h3 class="inline m-r-4" i18n>Container DMRL</h3>
    </div>
    <div class="pure-u-md-14-24 pure-u-lg-10-24 right">
      <app-dmrl-search class="search-bar" [workOrderSearchTextForm]="filterFormGroup.controls.workOrderSearchTextForm"></app-dmrl-search>
    </div>
  </div>

  <app-dmrl-filter [filterFormGroup]="filterFormGroup"></app-dmrl-filter>
  <app-dmrl-grid [filterFormGroup]="filterFormGroup" class="table-container"></app-dmrl-grid>
</form>
